import { fetcher } from '../fetcher';
import {
  calculatorsSchema,
  calculationSchema,
  calculationsSchema,
  pricesSchema,
  simpleProductsSchema,
  allRulesSchema,
  simpleItemsSchema,
  grantDatasSchema,
} from '../schemas';
import type { Calculation } from '../types';

export const calculationService = {
  getCalculators: () => {
    return fetcher(
      `/calculators/all
      ?with[]=segments.viewGroups.views.items.products.productPrice
      &with[]=segments.viewGroups.views.items.products.productPrices
      &with[]=segments.viewGroups.views.items.products.educationalMaterials
      &with[]=segments.viewGroups.views.items.products.productOptions
      &with[]=segments.viewGroups.views.items.products.productGroups.product.productOptions
      &with[]=segments.viewGroups.views.links
      &with[]=segments.viewGroups.views.items.links
      &with[]=rules
      &with[]=segments.rules
      &with[]=segments.links
      &with[]=segments.viewGroups.rules
      `.replace(/\s+/g, ''),
      {
        method: 'GET',
        schema: calculatorsSchema,
      }
    );
  },
  saveCalculation: (calculation: Calculation) => {
    return fetcher(
      `/calculations/import
      ?with[]=calculationSegments.calculationSegmentItems`.replace(/\s+/g, ''),
      {
        method: 'POST',
        body: calculation,
        schema: calculationSchema,
      }
    );
  },
  getCalculations: () => {
    return fetcher(
      `/calculations/all
      ?with[]=calculationSegments.calculationSegmentItems
      &with[]=owner
      &with[]=calculationChildren
      &with[]=calculationChildren.owner
      &with[]=calculationChildren.calculationSegments.calculationSegmentItems`.replace(/\s+/g, ''),
      {
        method: 'GET',
        schema: calculationsSchema,
      }
    );
  },
  copyCalculation: (id: number) => {
    return fetcher(
      `/calculations/${id}/copy
      ?with[]=calculationSegments.calculationSegmentItems
      &with[]=owner`.replace(/\s+/g, ''),
      {
        method: 'POST',
        schema: calculationSchema,
      }
    );
  },
  getProductPrices: () => {
    return fetcher(`/product-prices/all`, {
      method: 'GET',
      schema: pricesSchema,
    });
  },
  getProducts: () => {
    return fetcher(
      `/products/all
      ?with[]=productGroups.product.productOptions
      &with[]=productOptions
      &with[]=productGroups.product.productPrice
      &with[]=productPrices
      &with[]=productPrice`.replace(/\s+/g, ''),
      {
        method: 'GET',
        schema: simpleProductsSchema,
      }
    );
  },
  getRules: () => {
    return fetcher(`/rules/all`, {
      method: 'GET',
      schema: allRulesSchema,
    });
  },
  getItems: () => {
    return fetcher(`/items/all`, {
      method: 'GET',
      schema: simpleItemsSchema,
    });
  },
  destroyCalculation: (id: number) => {
    return fetcher(`/calculations/${id}`, {
      method: 'DELETE',
    });
  },
  getGrants: () => {
    return fetcher(
      `/grant-programs/all
      ?with[]=grants
      &with[]=grants.grantLevels
      &with[]=grants.grantLevels.grantLevelOptions`.replace(/\s+/g, ''),
      {
        method: 'GET',
        schema: grantDatasSchema,
      }
    );
  },
};
